import AppView from "../../app-view";
import KnowledgeBaseDetailContent from "./components/KnowledgeBaseDetailContent";

const KnowledgeBaseDetail = () => {
  return <AppView title="Knowledge Base Detail" showHeader={false}>
    <KnowledgeBaseDetailContent />
  </AppView>
};

export default KnowledgeBaseDetail; 